export class BaseValidator {
    protected createMessage(type: string, message: string) {
        const ret = {};
        ret[type] = {};
        ret[type]['message'] = message;

        return ret;
    }
}
